<template>
  <div class="asset-drawer-title">
    <div class="asset-drawer-title__container">
      <div class="asset-drawer-title__area">
        <span class="asset-drawer-title__name">{{ name }}</span>
        <span v-if="isTickerVisible" class="asset-drawer-title__ticker">
          {{ ticker }}
        </span>
      </div>
      <div v-if="type" class="asset-drawer-title__type">
        {{ type }}
      </div>
    </div>
    <div v-if="showDate" class="asset-drawer-title__date">
      As of: {{ asOfDate }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { stringToLocalDateString } from '@/helpers/dates'

import { useRepositoriesStore } from '@/store/repositories/index'

type Props = {
  name: string
  ticker?: string
  type?: string
  showDate?: boolean
}

const props = defineProps<Props>()

const repositoriesStore = useRepositoriesStore()

const isTickerVisible = computed(
  () =>
    !!props.ticker &&
    props.ticker.toLocaleLowerCase() !== props.name.toLocaleLowerCase(),
)
const asOfDate = computed(() =>
  stringToLocalDateString(repositoriesStore.getCurrentTimelineEnd),
)
</script>

<style>
.asset-drawer-title {
  @apply flex items-start justify-between;
  @apply flex-row flex-wrap;
  @apply gap-1;

  &__container {
    @apply flex flex-col;
    @apply gap-y-1;
    @apply leading-none;
  }

  &__area {
    @apply flex items-start;
    @apply flex-row flex-wrap;
    @apply gap-2;
  }

  &__name {
    @apply sm:text-xl;
    @apply leading-none;
    @apply text-gray-500;
    @apply line-clamp-3;
  }

  &__ticker {
    @apply py-0.5 px-2;
    @apply rounded;
    @apply bg-indigo-600;
    @apply text-white;
    @apply text-sm sm:text-xs;
  }

  &__type {
    @apply text-xs leading-none;
    @apply text-gray-400;
  }

  &__date {
    @apply flex items-center sm:mt-1;
    @apply text-sm sm:text-base leading-none;
    @apply whitespace-nowrap;
    @apply text-gray-400;
  }
}
</style>
